import * as React from 'react';
import { useContext, useState } from 'react';
import { PropertyContext } from '../TourRouter';
import { ConfirmationSection } from './ConfirmationSection';
import { getReservationForGuestCard } from '../../../../../api/TourSignup';
import { useFetch } from '../../../../../hooks/useFetch';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import ReservationDisplay from '../display/ReservationDisplay';
import ProspectUpdateTourTimePopup from './ProspectUpdateTourTimePopup';

const ReservationConfirmationSection = (props: { guestCardGuid: string }) => {
    const property = useContext(PropertyContext);
    if (!property) {
        return null;
    }

    const {
        data: reservation,
        error: errorMessage,
        loading: isLoading,
        setData: setReservation
    } = useFetch(() => getReservationForGuestCard(props.guestCardGuid), [], undefined);

    const [modalOpen, setModalOpen] = useState(false);

    return (
        <ConfirmationSection
            headerText="Tour Time"
            hasIssue={isLoading ? undefined : !reservation}
            onEditClick={() => setModalOpen(true)}
            alwaysShowEditButton={true}
        >
            <>
                {reservation ? (
                    <div>
                        <ReservationDisplay reservation={reservation} />
                    </div>
                ) : (
                    <>
                        {!isLoading && (
                            <div>
                                <FormValidationDisplay
                                    errorMessage={
                                        errorMessage ? errorMessage : 'Your reservation has expired'
                                    }
                                />
                            </div>
                        )}
                    </>
                )}
                <ProspectUpdateTourTimePopup
                    isOpen={modalOpen}
                    close={() => setModalOpen(false)}
                    currentReservation={reservation}
                    propertyId={property.id}
                    guestCardGuid={props.guestCardGuid}
                    updateReservation={setReservation}
                />
            </>
        </ConfirmationSection>
    );
};

export default ReservationConfirmationSection;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/confirmation/ReservationConfirmationSection.tsx